module.exports = __webpack_public_path__ + "img/Free hand.9cc01821.png";